(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.checkCurrency();
      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
              document.addEventListener('DOMContentLoaded', function () {
                // Delegate click handler for all upsell buttons
                document.body.addEventListener('click', function (evt) {
                  var btn = evt.target.closest('.js-upsell-add');
                  if (!btn) return;
                  evt.preventDefault();

                  var variantId = btn.getAttribute('data-variant-id');
                  if (!variantId) return;

                  // Disable button while adding
                  btn.disabled = true;
                  btn.querySelector('.added').classList.add('hidden');
                  btn.querySelector('.loading').classList.remove('hidden');
                  btn.querySelector('.add').classList.add('hidden');

                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 }),
                  })
                    .then(function (resp) {
                      if (!resp.ok) throw new Error('Network error');
                      return resp.json();
                    })
                    .then(function (itemData) {
                      if (typeof umami !== 'undefined') {
                        umami.track('upsell-addToCart', {
                          product: itemData.product_title,
                          sku: itemData.sku,
                          price: itemData.price / 100,
                        });
                      }
                      // Success feedback
                      btn.querySelector('.added').classList.remove('hidden');
                      btn.querySelector('.loading').classList.add('hidden');
                      btn.querySelector('.add').classList.add('hidden');

                      theme.addItemToCart(itemData);
                    })
                    .catch(function (err) {
                      console.error(err);
                      btn.textContent = 'Error';
                    })
                    .finally(function () {
                      setTimeout(function () {
                        btn.disabled = false;
                        btn.querySelector('.added').classList.add('hidden');
                        btn.querySelector('.loading').classList.add('hidden');
                        btn.querySelector('.add').classList.remove('hidden');
                      }, 1500);
                    });
                });
              });
            
  } catch(e) { console.error(e); }
})();
})();
